import type { TotalPointParams } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

export const useConsumablePoints = (
  params?: TotalPointParams,
  options?: SWRConfiguration,
) => {
  const client = useGyymClient()
  const { isVerified } = useAuthUser()

  return useGyymSWR(
    // Only fetch if the user is logged in and params are passed
    isVerified && params ? [client.user.points.getTotalPoint, params] : null,
    options,
  )
}
